import React from 'react'

const Section3 = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-lg-5" style={{ paddingTop: "100px", paddingBottom: "50px" }}>
        <h2 className='scroll-fade-in'>Check it out</h2>
        <p className='px-4 text-center scroll-fade-in'>Watch our quick overview and get a taste of what's in the store.</p>
        <div className='ratio ratio-16x9 w-75 m-4 scroll-fade-in'>
          <iframe src="https://www.youtube.com/embed/pwWQz1Up-Pc" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>
  )
}

export default Section3